"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordForm = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var il_box_common_1 = require("../il-box/il-box.common");
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_form_label_common_1 = require("../il-form-label/il-form-label.common");
var il_button_common_1 = require("../il-button/il-button.common");
var il_textfield_common_1 = require("../il-textfield/il-textfield.common");
var forgot_password_validation_1 = require("./forgot-password.validation");
var ForgotPasswordForm = function (props) {
    var formik = (0, formik_1.useFormik)({
        initialValues: {
            email: '',
        },
        validationSchema: forgot_password_validation_1.ForgotPasswordFormValidation,
        onSubmit: function (formValues) {
            props.onSubmit(formValues);
        },
    });
    var values = formik.values, handleChange = formik.handleChange, touched = formik.touched, errors = formik.errors, isValid = formik.isValid, dirty = formik.dirty, handleSubmit = formik.handleSubmit, setFieldValue = formik.setFieldValue;
    react_1.default.useEffect(function () {
        if (props.email) {
            setFieldValue('email', props.email);
        }
    }, [props.email, setFieldValue]);
    return (react_1.default.createElement(il_box_common_1.ILFormBox, { sx: __assign(__assign({}, il_box_common_1.ILFormBoxArgs.sx), { maxWidth: 374 }) },
        react_1.default.createElement(material_1.Typography, { sx: {
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
            }, color: "text.primary", variant: enums_1.TypographyVariantEnum.H2 }, "Forgot Password"),
        react_1.default.createElement(material_1.Typography, { sx: {
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                mx: { md: 5, xs: 3 },
                py: 1,
                fontSize: 'button.fontSize',
                lineHeight: 1.62,
                fontWeight: 'normal',
                textTransform: 'unset',
            }, color: "text.secondary", variant: enums_1.TypographyVariantEnum.H3 }, "We will send you instructions on how to reset your password by email."),
        react_1.default.createElement("form", { onSubmit: handleSubmit },
            react_1.default.createElement(il_box_common_1.ILFormItemBox, { sx: __assign(__assign({}, il_box_common_1.ILFormItemBoxArgs.sx), { marginBottom: '0.5rem', gap: 1, mt: 0 }) },
                react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Email"),
                react_1.default.createElement(il_textfield_common_1.EmailTextField, { id: 'email', value: values.email, onChange: handleChange, error: touched.email && Boolean(errors.email), helperText: touched.email && errors.email })),
            react_1.default.createElement(material_1.Box, { sx: {
                    justifyContent: 'center',
                    textAlign: 'center',
                    px: { md: 3, sm: 2, xs: 1 },
                } },
                react_1.default.createElement(il_button_common_1.ContainedButton, { sx: __assign(__assign({}, il_button_common_1.ContainedButtonArgs.sx), { width: '100%', height: 48, fontSize: 'h5.fontSize', mt: '1.5rem' }), type: enums_1.ButtonTypeEnum.SUBMIT, disabled: !(isValid && dirty) }, "Submit")),
            react_1.default.createElement(material_1.Typography, { sx: {
                    justifyContent: 'center',
                    textAlign: 'center',
                    fontSize: 'button.fontSize',
                    mx: { md: 5, xs: 2 },
                    mt: 1,
                    textTransform: 'unset',
                }, color: "text.secondary", variant: enums_1.TypographyVariantEnum.BODY2 },
                "Students, teachers can reset your password by finding your name under",
                ' ',
                react_1.default.createElement("b", null, "Profile Settings")))));
};
exports.ForgotPasswordForm = ForgotPasswordForm;
